var SingleLanguage;
(function (SingleLanguage) {
    SingleLanguage["English"] = "en";
    SingleLanguage["French"] = "fr";
})(SingleLanguage || (SingleLanguage = {}));
export default SingleLanguage;
